import React, { useEffect, useState, useMemo } from "react";
import "./Product_details.css";
import Breadcrumb_comp from "../common-components/breadcrumb-comp/Breadcrumb_comp";
import Our_choices from "./our_choices/Our_choices";
import Product_details_swiper from "./product_details_swiper/Product_details_swiper";
import Product_info from "./product_info/Product_info";
import Product_overview from "./product_overview/Product_overview";
import Product_Rating from "./product_Rating/Product_Rating";
import {
  getProduct,
} from "../../features/products/productsSlice";
import { decodeId, variant_type } from "../../utils/common";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { AvgReviewRating } from "../../features/review_rating/review_ratingSlice";

function Product_details() {
  const { id } = useParams();
  const dispatch = useDispatch();

  const [productId, setProductId] = useState(null);
  const [selectedVariant, setselectedVariant] = useState({});
  const [activeMetal, setActiveMetal] = useState(null);
  const [activeSize, setActiveSize] = useState(null);
  const [activeTriple, setActiveTriple] = useState(null);

  const product = useSelector((state) => state.product.product);
  const avg_rating = useSelector((state) => state.reviewRating.avg_rating);

  const breadcrumbs = useMemo(
    () => [
      {
        label: "Home",
        link: "/",
        isActive: false,
      },
      {
        label: product?.product_name || product?.name || "Product",
        link: "",
        isActive: true,
      },
    ],
    [product]
  );

  useEffect(() => {
    if (id) {
      const decoded = decodeId(id);
      setProductId(decoded);
    }
  }, [id]);

  useEffect(() => {
    if (productId) {
      dispatch(getProduct(productId));
    }
  }, [dispatch, productId]);

  useEffect(() => {
    let firstMetal;
    let firstSize;
    let firstTriple;

    if (Number(product?.variant_type_id) === variant_type.Single) {
      firstMetal = product?.Product_Variants?.[0];
    } else if (Number(product?.variant_type_id) === variant_type.Double) {
      firstMetal = product?.Product_Variants?.[0];
      firstSize = firstMetal?.Double_Variants?.[0];
    } else if (Number(product?.variant_type_id) === variant_type.Triple) {
      firstMetal = product?.Product_Variants?.[0];
      firstSize = firstMetal?.Double_Variants?.[0];
      firstTriple = firstSize?.Triple_Variants?.[0] || null;
    }

    setActiveMetal(firstMetal || null);
    setActiveSize(firstSize || null);
    setActiveTriple(firstTriple || null);
    setselectedVariant(firstTriple || firstSize || firstMetal);
  }, [product]);

  useEffect(() => {
    if (product?.id) {
      dispatch(
        AvgReviewRating({
          product_id: product.id,
        })
      );
    }
  }, [dispatch, product]);

  return (
    <>
      <section className="Product_details">
        <div className="container">
          <Breadcrumb_comp breadcrumbs={breadcrumbs} />

          <div className="Product_details_holder">
            <div className="row">
              <div className="col-xl-4 col-md-4">
                <Product_details_swiper
                  product={product}
                  selectedVariant={selectedVariant}
                />
              </div>

              <div className="col-xl-8 col-md-8">
                <div className="Product_details_info_holder">
                  <Product_info
                    product={product}
                    avg_rating={avg_rating}
                    selectedVariant={selectedVariant}
                    setSelectedVariant={setselectedVariant}
                    activeTriple={activeTriple}
                    activeSize={activeSize}
                    activeMetal={activeMetal}
                    setActiveTriple={setActiveTriple}
                    setActiveSize={setActiveSize}
                    setActiveMetal={setActiveMetal}
                  />

                  {product?.description_status &&
                    product?.description && (
                      <div className="product_description_holder mt-4">
                        <h4 className="heading_text">
                          About This Item
                        </h4>

                        <div
                          className="overview_content"
                          dangerouslySetInnerHTML={{
                            __html: product.description,
                          }}
                        />
                      </div>
                    )}
                </div>
              </div>
            </div>

            <hr />

            <Product_overview product={product} />
          </div>

          <Our_choices product={product} />

          <Product_Rating
            product={product}
            avg_rating={avg_rating}
          />
        </div>
      </section>
    </>
  );
}

export default Product_details;